// extracted by mini-css-extract-plugin
export var currencyInput = "_od-1";
export var currencySymbol = "_od-0";